import { render, staticRenderFns } from "./newsinfo.vue?vue&type=template&id=2778e1f3"
import script from "./newsinfo.vue?vue&type=script&lang=js"
export * from "./newsinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports